import { Extension } from "@tiptap/core";

import { COLLAPSIBLE_TYPES } from "./Collapse";

export type LockBlockOptions = {
  types: string[];
};

export const LOCKABLE_TYPES: string[] = [...COLLAPSIBLE_TYPES];

export const LockBlock = Extension.create<LockBlockOptions>({
  name: "lockBlock",

  addOptions() {
    return {
      types: LOCKABLE_TYPES,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          locked: {
            default: false,
            keepOnSplit: true,
            parseHTML: (element) => element.dataset.locked === "true",
            renderHTML: ({ locked }: { locked?: boolean }) => {
              if (!locked) {
                return {};
              }

              return { "data-locked": "true" };
            },
          },
        },
      },
    ];
  },
});
